import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { validateEmailOrPhone } from 'core/validators';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import * as auth from 'core/auth';
import router from 'src/router';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface OrderComponentModel {
    submitted: boolean;
    error: string;
    orderNumber: string;
    orderContact: string;
}

@WithRender
@Component({
    validations: {
        model: {
            orderNumber: { required, minLength: minLength(7), maxLength: maxLength(7) },
            orderContact: { required, minLength: minLength(5), validateEmailOrPhone }
        }
    }
})
export default class OrderComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init
    $ga: utils.GoogleAnalyticsService; // Injected in G2S.init
    gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

    model: OrderComponentModel = {
        submitted: false,
        error: '',
        orderNumber: '',
        orderContact: ''
    }

    tooltipActivator: string | null = null;
    tooltipText: string | null = null;
    tooltipVisible: boolean = false;
    tooltipTimeout: number | null = null;


    onOrderContactInput(value: string) {
        if (value.length === 1 && value === '8') {
            this.model.orderContact = '+7';
        }
        this.model.orderContact = utils.String.disabledCyrillic(
            this.model.orderContact,
            () => {
                this.showTooltip(
                    (<any>this.$refs).orderContact.$el,
                    i18next.t('error_letters_latin_numbers_symbols_only_no_specifics')
                );
            },
        );

        (<any>this.$refs).orderContact.lazyValue = this.model.orderContact;
    }
    

    onOrderNumberInput() {
        this.model.orderNumber = utils.String.normalizeNumber(
            this.model.orderNumber
        );
        // Hack to render new value
        (<any>this.$refs).orderNumber.lazyValue = this.model.orderNumber;
    }

    onSubmit() {
        (<any>this).$ga.sendEvent('order.view', 'btn.find', 'order.view.btn.find', this.gaParams);

        this.model.error = '';
        this.$v.model!.$touch();
        
        if ((<any>this).$v.model.orderNumber.$error) {
            this.model.error = i18next.t('error_order_notvalid');
        } else if ((<any>this).$v.model.orderContact.$error) {
            this.model.error = i18next.t('error_email_or_phone_wrong');
        } else if (G2S.config.theme === 'megotravel') {
            this.model.error = i18next.t('error_email_or_phone_wrong');
        }

        if (this.$v.model!.$error || this.model.error) {
            (<any>this.$root).$refs.dialogMessage.show({
                title: i18next.t('error'),
                text: this.model.error
            });
            (<any>this).$ga.sendEvent('order.view', 'error', 'order.view.error', this.gaParams);
            return;
        }

        const request: api.GetReservationPublicIdRequest = {
            reservationNumber: this.model.orderNumber,
            emailOrPhone: this.model.orderContact
        };

        this.model.submitted = true;

        new api.ReservationService().getReservationPublicId(request).then(
            (result: api.GetReservationPublicIdResponse) => {
                this.model.submitted = false;

                (<any>this).$ga.sendEvent('order.view', 'submit.success', 'order.view.submit.success', this.gaParams);
                router.push('/order/' + result.reservationPublicId);
            },
            (error) => {
                this.model.submitted = false;

                (<any>this).$ga.sendEvent('order.view', 'error', 'order.view.error', this.gaParams);
                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: i18next.t('error_order_notfound_bydetails')
                });

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    showTooltip(target, text) {
        (<any>this).$refs.tooltip.isActive = false;

        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }

        this.$nextTick(() => {
            this.tooltipText = text;
            this.tooltipActivator = target;
            (<any>this).$refs.tooltip.isActive = true;

            this.tooltipTimeout = window.setTimeout(() => {
                (<any>this).$refs.tooltip.isActive = false;
            }, 2000);
        });
    }
}
